import React, { FC } from "react";
import { AdminApplicationsView } from "../../components";

export const AdminApplicationsPage: FC = () => {
  return <AdminApplicationsView />;
};
